import Tooltip from 'bootstrap/js/dist/tooltip';

const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
tooltipElements.forEach((element) => new Tooltip(element));
